/** 管理员重置用户密码时的默认密码 */
export const USER_RESET_DEFAULT_PASSWORD = 'temp123!@#'
